<template>
  <v-container class="account">
    <!-- META-DATA -->
    <vue-headful
      :title="this.$store.state.app.meta.title + this.$store.state.app.meta.titleSuffix"
      :description="null" />

    <!-- TOOLBAR -->
    <div
      class="account-toolbar"
      :class="{
        'account-toolbar--above-drawer': accountNavDrawer!==true
      }">
      <h2 class="account-toolbar__header title">
        <v-btn
          flat
          icon
          class="account-toolbar__nav-menu-button"
          @click.stop="accountNavDrawer = !accountNavDrawer">
          <v-icon>
            menu
          </v-icon>
        </v-btn>
        <v-icon
          class="account-toolbar__header-icon">
          {{ currentRoute.icon }}
        </v-icon>
        {{ currentRoute.name }}
      </h2>
    </div>

    <div class="account-layout">
      <!-- NAV DRAWER -->
      <div
        class="account-nav-drawer__wrapper"
        :class="{
          'account-nav-drawer__wrapper--active': accountNavDrawer
        }">
        <v-navigation-drawer
          v-model="accountNavDrawer"
          mobile-break-point="768"
          width="250"
          class="account-nav-drawer">
          <nav class="account-nav">
            <div class="account-nav__header-row">
              <h4 class="account-nav__header-title title">
                Account
              </h4>
              <v-btn
                icon
                class="account-nav-drawer__close-button"
                @click.stop="accountNavDrawer = !accountNavDrawer">
                <v-icon>
                  close
                </v-icon>
              </v-btn>
            </div>
            <div class="account-nav__body">
              <router-link
                v-for="route in routes"
                :key="route.path"
                v-ripple
                :to="{ path: route.path }"
                active-class="nav-item--active"
                class="nav-item">
                <v-icon class="nav-item__icon">
                  {{ route.icon }}
                </v-icon>
                <span class="nav-item__label">
                  {{ route.name }}
                </span>
              </router-link>
            </div>
          </nav>
        </v-navigation-drawer>
      </div>

      <v-scroll-y-reverse-transition mode="out-in">
        <router-view class="account-layout__inner" />
      </v-scroll-y-reverse-transition>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Account',
  data() {
    return {
      accountNavDrawer: null,
      routes: [
        {
          path: 'profile',
          name: 'profile',
          icon: 'account_box',
        },
        {
          path: 'order-history',
          name: 'order history',
          icon: 'receipt',
        },
        {
          path: 'my-patches',
          name: 'my patches',
          icon: 'view_agenda',
        },
        /*
        {
          path: 'settings',
          name: 'settings',
          icon: 'settings'
        }
        */
      ],
    };
  },
  computed: {
    currentRoute() {
      return this.routes.find(
        route => `/account/${route.path}` === this.$route.path,
      );
    },
  },
  created() {
    // refresh customer data from server
    this.$store.dispatch('user/getUser', this.$store.state.user.currentUser.publicId);
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')

.account-toolbar
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: space-between
  border-bottom: 1px solid $accent
  &--above-drawer
    position: relative
    z-index: 4
  &__header
    display: flex
    flex-flow: row nowrap
    align-items: center
    padding: $base-padding
    padding-left: 0
    @media screen and (max-width: 48rem)
      padding: 0
    &-icon
      color: $accent

.account-toolbar__nav-menu-button,
.account-nav-drawer__close-button
  @media screen and (min-width: 48rem)
    display: none

.account-layout
  display: flex
  flex-flow: row nowrap
  align-items: stretch
  align-content: stretch
  justify-content: space-between
  width: 100%
  @media screen and (max-width: 48rem)
    flex-flow: column nowrap

  &__inner
    display: flex
    flex-flow: column nowrap
    align-items: center
    justify-content: flex-start
    width: 100%

// NAV DRAWER
.account-nav-drawer
  background-color: $white
  &__wrapper
    @media screen and (max-width: 48rem)
      position: absolute
      top: 0
      left: -1px
      height: 100%
      min-height: 100vh
      z-index: 0
      &--active
        z-index: 5

.account-nav
  &__header-row
    flex-flow: row nowrap
    align-items: center
    justify-content: space-between
    display: none
    @media screen and (max-width: 48rem)
      display: flex
      padding-bottom: 0
      padding-left: $base-padding*2
      border-bottom: 1px solid $accent

  &__body
    display: flex
    flex-flow: column nowrap
    align-items: flex-start
    justify-content: flex-start

.nav-item
  position: relative
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: flex-start
  width: 100%
  padding-top: $base-padding
  padding-bottom: $base-padding
  color: $primary
  text-decoration: none
  opacity: $base-opacity
  cursor: pointer
  @media screen and (max-width: 48rem)
    padding-left: $base-padding*2
  // copies vuetify button styles
  &::before
    content: ''
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    color: inherit
    opacity: .12
    transition: $base-transition
  &:hover::before,
  &--active::before
    background-color: $primary

  &__icon
    padding-right: $base-padding
    color: inherit
  &__label
    text-transform: capitalize
    color: inherit

</style>
